import React, {useEffect, useState, useMemo} from 'react';
import {
  Grid,
  TextField, Stepper, Step, Popper, Stack, 
  Paper, Typography, Autocomplete, Alert,  Box,
  Button, MenuItem, Select,
} from '@mui/material';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';


import { useSelector,useDispatch } from 'react-redux';

import {RenderVisitorPhone, RenderVisitorName, RenderVisitorEmail, 
    filterVisitorNameOptions, filterVisitorPhoneOptions,  filterVisitorEmailOptions} 
from './RenderVisitorAutoCompleteUtils'

//import VisitorDialog from './VisitorDialog'
import AddIcon from '@mui/icons-material/Add';
import{useDataListContext} from '../utils/DataListContext'
import {usePlayContext} from '../utils/PlayContext';

import { createVisitor, selectAllVisitors, selectAllCompanies, selectAllEmails, selectAllPhones }
from '../store/visitorSlice';

import { regexEmail, regxCountyCode, regxPhoneNumber } from '../utils/ValidationConst';

import { derivePhone, generatePhoneDetail,  } from '../utils/phoneUtil';
import {removeExtendedSpacing} from '../utils/nameUtil';

const InviteEditorView=()=>{

  const dispatch = useDispatch()
  const {setOp,
    status, setStatus, appTitle, setAppTitle, 
    errorMessage, setErrorMessage, errorTitle, setErrorTitle,
    openSnackToast,
    }=usePlayContext()

  const {listData,  deleteDataList: doDeleteVisitor, addDataList} = useDataListContext();
  
    
  const [selectedVisitor, setSelectedVisitor] = React.useState()

  const [countryCode, setCountryCode] = React.useState('65')
  const [countryCodeError, setCountryCodeError] = React.useState('')
  const [phoneNumber, setPhoneNumber] = React.useState('')
  const [phoneNumberError, setPhoneNumberError] = React.useState('');


  const [email, setEmail] = React.useState('')
  const [emailError, setEmailError] = React.useState('')
  
  const [name, setName] = React.useState('');
  const [nameError, setNameError] = React.useState('');
  
  const [company, setCompany] = React.useState('');

  const [companyError, setCompanyError] = React.useState('');

  const allEmails = useSelector(selectAllEmails)
  const allPhones = useSelector(selectAllPhones)
  const allCompanies = useSelector(selectAllCompanies)

    const allVisitors = useSelector(selectAllVisitors)
  const filteredVisitors = useMemo(()=>{
      if (!listData || listData.length===0) return allVisitors;
      let set = new Set(listData.filter(x=>Boolean(x.email)).map(x=>x.email))
      return allVisitors.filter(x=>
        {
          let b = set.has(x.email);
          //console.log(x.email+", "+b)
          return !b;
        });
    },
    [listData, allVisitors]

  )

  const isPhoneNumberValid=Boolean(phoneNumber) && phoneNumber.match(regxPhoneNumber) 
  const isCountryCodeValid = !Boolean(countryCode) || countryCode.match(regxCountyCode)

  const isEmailValid=Boolean(email) && email.match(regexEmail)

  const isCreatable = 
        isCountryCodeValid
        && isPhoneNumberValid
        && isEmailValid && Boolean(name) && Boolean(company)  && 
        Boolean(name.trim()) && Boolean(company.trim())


  const handleReset=()=>{
      setName('')
      setNameError('')

      setCountryCode('65')
      setCountryCodeError('')
      setPhoneNumber('')
      setPhoneNumberError('')


      setEmail('')
      setEmailError('')
      setCompany('')
      setCompanyError('')
      setSelectedVisitor(undefined)
  }
  
  
  
  const searchEmail=()=>
  {
    doSearchEmail(email)
  }

  const doSearchEmail= async(email)=>
  {
    let email1 = email? email.toLocaleLowerCase().trim():''
    setNameError('')
    setCompanyError('')
    setCompanyError('')
    setPhoneNumberError('')
    setEmailError('')
    let x = allVisitors.find(x=>x.email===email1)
    setSelectedVisitor(x)
    if (!x)
    {
      setEmailError('No Hits of this email')
    }
    else
    {
      setName(x.name)
      setCompany(x.company)
      setPhoneNumber(x.phoneNumber)
      setCountryCode(x.countryCode)
      setEmail(x.email)
        
    }
  }
  const doVisitorSelectered= (visitor)=>
  {
      setNameError('')
      setCompanyError('')
      setPhoneNumberError('')
      setCountryCodeError('')
      setEmailError('')
    
      setName(visitor.name ? visitor.name:'')
      setCompany(visitor.company ? visitor.company:'')
      setCountryCode(visitor.countryCode ? visitor.countryCode:'65')
      
      setPhoneNumber(visitor.phoneNumber ? visitor.phoneNumber:'')
      setEmail(visitor.email ? visitor.email:'')

      setSelectedVisitor(visitor)
        
    
  }
  const doInvite= ()=>
  {
      if (!selectedVisitor) return

      setNameError('')
      setCompanyError('')
      setCountryCodeError('')
      setPhoneNumberError('')
      
      let err=0
      if (!isEmailValid)
      {
        err++
        setEmailError('Email is invalid')
      }
      if (!isPhoneNumberValid)
      {
        err++
        setPhoneNumberError('Phone Number is invalid')
      }

      if (!isCountryCodeValid)
      {
        err++
        setCountryCodeError('Invalid')
      }

      
      const email1=email.toLocaleLowerCase().trim()
      const phone1='65'===countryCode ?  phoneNumber : '+'+countryCode+ ' '+phoneNumber
      
      let x = listData.find((x)=>x.email === email1)
      if (x)
      {
        setEmailError('The email has been invited')
        err++;
      }
      x = listData.find((x)=>x.phone === phone1)
      if (x)
      {
        setPhoneNumberError('Phone Number already invited')
        err++;
      }

      if (err>0) return
      
      let y={...selectedVisitor}
      y.visitorId=selectedVisitor.id
      
       
      addDataList(y)
      setOp('')
      
      //setStatus('idle')
  }
  const doInviteProfile= ()=>
  {
      setNameError('')
      setCompanyError('')
      setPhoneNumberError('')
      setCountryCodeError('')
      let err=0
      //setStatus('processing')
      if (!isEmailValid)
      {
        err++
        setEmailError('Email is invalid')
      }
      
      
      const email1=email.toLocaleLowerCase().trim()
      
      let x = listData.find((x)=>x.email === email1)
      if (x)
      {
        setEmailError('The email has been invited')
        err++;
      }
      if (err>0) return
      
      x = allVisitors.find(x=>x.email===email1)
      if (!x)
      {
            x = {
              email:email1,
              countryCode:'',
              phoneNumber:'',
              phoneDisplay:''
            }
            addDataList(x)
            setOp('')
       }
      else
      {
        setEmailError('Email already exists')  
      }
      
      
      
      
      //setStatus('idle')
  }
  const doCreate = async()=>
  {
      let err=0
      const email1=email.toLocaleLowerCase()
      
     if (!isEmailValid)
     {
        err++
        setEmailError('Email is invalid')
     }
     else
     {
        let x = allEmails.find(x=>x === email1) 
        if (x)
        {
          setEmailError('The email already exist')
          err++;
        }
        else
        {
          let x = listData.find((x)=>x.email === email1)
          if (x)
          {
            setEmailError('The email has been invited')
            err++;
          }
          
        }
      }

      let countryCode1 = Boolean(countryCode) ? countryCode : '65' 

      if (!isCountryCodeValid)
      {
          err++
          setCountryCodeError('Invalid')
      }
      else setCountryCodeError('')
      
      if (!Boolean(phoneNumber))
      {
        err++
        setPhoneNumberError('Phone Number is required')
      }
      else if (!isPhoneNumberValid)
      {
          err++
          setPhoneNumberError('Phone Number invalid')
      }
      else setPhoneNumberError('')

      let phone1
      let phone2
      
      let phoneDisplay

      if ('65'=== countryCode1)
      {
          phone1 = phoneNumber
          phone2= "+65 "+phoneNumber
          phoneDisplay = '+65-'+phoneNumber
      }
      else
      {
          phone2 = phone1 = '+'+countryCode1+' '+phoneNumber;
          phoneDisplay = '+'+countryCode1+'-'+phoneNumber;
      }

      
      let x = allPhones.find(x=>(x === phone1 ||x === phone2)) 
      if (x)
      {
            setPhoneNumberError('Phone Number already exist')
            err++;
      }
      else
      {
            let x = listData.find((x)=>x.phone === phone1)
            
            if (x)
            {
              setPhoneNumberError('Phone Number already exist')
              err++;
            }
            else setPhoneNumberError('')
      }
      
      
      if (!Boolean(name) || !Boolean(name.trim()) )
      {
          err++
          setNameError('Name is required')
      }
      else if(name.length>30)
      {
        err++
        setNameError('Name cannot exceed 30 letters')
      }
      if (!Boolean(company) || !Boolean(company.trim()) )
      {
          err++
          setCompanyError('Company is required')
      }
      else if(company.length>50)
      {
        err++
        setCompanyError('Company cannot exceed 50 letters')
      }
      
      if (err>0) return;

      setStatus('processing')
      setEmailError('')
      setPhoneNumberError('')
      setCountryCodeError('')
      setNameError('')
      setCompanyError('')
      setErrorMessage('')
      setErrorTitle('')
      
      try
      {
        setStatus('processing')
        //let x = await apply();

        let vv = {
          email:email1,
	        name:removeExtendedSpacing(name.trim()),
          company:company.trim(),
          phone  : phone1
	      
        };
        let app1 = await dispatch(createVisitor(vv)).unwrap()

        setStatus('success')

        phone1 = app1.phone

        let x={
          email:app1.email, 
          phone:app1.phone, 
          visitorId:app1.id, 
          name:app1.name, company:app1.company, 
          host:app1.host, 
          tenantId:app1.tenantId,
          phoneDisplay,
          countryCode,
          phoneNumber,
        }
        
        addDataList(x)
        openSnackToast('Visitor has been created')
        setOp('')
      }
      catch (ex){
        setErrorMessage("Visitor Creation Error")
        setStatus('error')
        console.error("xxx::"+ex.message);

      }
  }
  

  return (
    <Grid  container  spacing={1} 
        sx={{p:1,border:1, borderColor:'#888888', borderRadius:0, mb:2,
          bgcolor:'#FFFFFF'}}>
      
      <Grid item xs={12} sm={6} lg={3} >
         
            <TextField 
                // required
                fullWidth
                value={name}
                id="id_name" 
                label="Name" 
                size='small'
                type="text" 
                error={Boolean(nameError)}
                onChange = { e=>setName(e.target.value)}
                inputProps={{ maxLength: 40, minLength:5 }}
                helperText={ nameError}/>
      </Grid>
      <Grid container item xs={12} sm={6} lg={3} sx={{display:'inline-flex'}}   >
          <Grid item xs={4}>
                <TextField
                    fullWidth
                    //required
                    size='small'
                    label={<small>Country Code</small>}
                    type="number"
                    id="id_phone_counter_code"
                    value={countryCode}
                    onChange={e=>setCountryCode(e.target.value)}
                    error={Boolean(countryCodeError)}
                    inputProps= {{ 
                      max: 999, min: 1 ,
                      maxLength:3
                    }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><strong>+</strong></InputAdornment>,
                  }}
                  helperText={<small>{ Boolean(countryCodeError) ? countryCodeError:'Country Code'}
                  </small>}
                  />
                </Grid>
                <Grid item xs={7} sx={{backgroundColor:'nnnn'}}>
                <TextField
                    fullWidth
                    error={Boolean(phoneNumberError)}
                    sx={{mx:0.5}}
                    value={phoneNumber}
                    onChange={e=>setPhoneNumber(e.target.value)}
                    //required
                      size='small'
                      label="Phone Number"
                      type="number"
                      id="id_phone_number"
                      helperText={ Boolean(phoneNumberError)?phoneNumberError:'Phone Number' }
                />
                </Grid>
          
      </Grid>

      <Grid item xs={12} sm={6} lg={3}  >
          <Autocomplete 
                fullWidth
                disableClearable
                forcePopupIcon={false}
                freeSolo
                size='small'
                id="id_email" 
                getOptionLabel={(option) => option.email}
                filterOptions={filterVisitorEmailOptions}

                renderOption={(props, option) => (
                    <RenderVisitorEmail props={props} option={option} />
                )}
                onInputChange = { (e, v)=>{setEmail(v);}}
                inputValue={email}

                //value={email}
                //getOptionLabel={ (option) => option}
                //options={allEmails} 
                options={allVisitors}
                //onChange = { (e, newValue)=>{;   } }
                //onChange = { (e, newValue)=>{setEmail(newValue);doSearchEmail(newValue);}}
                onChange = { (e, newValue)=>{doVisitorSelectered(newValue)}}

                renderInput={(params) => 
                    <TextField {...params} 
                      required
                      
                      error={Boolean(emailError)}
                      label="Email"  
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (

                          <InputAdornment position="end">
                            <IconButton 
                              sx={{display:isEmailValid? 'block' : 'none', }}
                              onClick={searchEmail}
                                >
                            <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      //inputProps={{ maxLength: 100, minLength:5 }}
                      helperText={ emailError}
                      />}

                />
      </Grid>
      <Grid item xs={12} sm={6} lg={3} sx={{  }}>
      <Autocomplete 
                fullWidth
                freeSolo
                size='small'
                id="id_company" 
                value={company}
                options={allCompanies} 
                onChange = { (e, newValue)=>{setCompany(newValue);}}
                renderInput={(params) => 
                    <TextField {...params} 
                      // required
                      onChange = { e=>{setCompany(e.target.value);}}
                      error={Boolean(companyError)}
                      label="Organization"  
                      
                      //inputProps={{ maxLength: 100, minLength:5 }}
                      helperText={ companyError}
                      />}

                />
        </Grid>        
        <Grid item xs={12}  sx={{   }} >
          <Box sx={{ display:'flex', flexDirection:'row', justifyContent: 'space-evenly' , m:0,p:0, 
              width:'100%'}}>
              <Button variant="outlined"size='small' 
                        color='success' 
                        sx={{textTransform:'none'}}
                        disabled={  !isCreatable || !Boolean(selectedVisitor) 
                          || name!==selectedVisitor.name 
                          || derivePhone(countryCode,phoneNumber)!==selectedVisitor.phone
                          || email!==selectedVisitor.email
                          || company!==selectedVisitor.company}
                        onClick={doInvite}
                    >
                  Invite
              </Button>
              <Button variant="outlined"size='small' 
                        color='secondary' 
                        sx={{textTransform:'none'}}
                        //disabled={!isEmailValid}
                        disabled={  !isEmailValid ||
                          email===selectedVisitor?.email 
                        }
                      
                        onClick={doInviteProfile}
                    >
                  Profile Request
              </Button>
              <Button variant="outlined"size='small' 
			  color='success' 
                      //variant='contained'
                      sx={{textTransform:'none'}}
                        onClick={doCreate}
                        //disabled={!isCreatable}
                        disabled={  !isCreatable ||
                          (	Boolean(selectedVisitor) 
                            && (email===selectedVisitor.email || 
                              derivePhone(countryCode,phoneNumber)===selectedVisitor.phone)
                           )
                          }
                    >
                  
                  Create
              </Button>
                  
            <Button variant="outlined"size='small' color='info' 
                      sx={{textTransform:'none'}}
                        onClick={handleReset}
                        disabled={![phoneNumber, email, name,company].some(Boolean)}
                        >
                Clear
            </Button>
                   
           <Button variant="outlined"size='small' 
				color='primary' 
                sx={{textTransform:'none'}}
                  //variant='contained'
                        onClick={e=>setOp('')}>
              
              Back
           </Button>
          
          
          </Box>
        </Grid>


    </Grid>

  )
  
}



export default InviteEditorView;
